// extracted by mini-css-extract-plugin
module.exports = {"columnNarrow":"rates_table_header_columnNarrow__1N8Jy","tableHeaderWrapper":"rates_table_header_tableHeaderWrapper__3WVNV"};